import { regions } from '../constants/region';
import { getRegion, getUserField } from './session-util';

// based on region, return background colors

export const getRegionalColors = () => {
  const selectedRegion = getRegion();
  let regionCode = regions.USA;

  if (!!selectedRegion) {
    regionCode = selectedRegion === regions.CAN ? regions.CAN : regions.USA;
  } else {
    const languageCode = !!getUserField('defaultLanguageCode')
      ? getUserField('defaultLanguageCode').toUpperCase()
      : navigator.language.toUpperCase();
    switch (languageCode) {
      case 'EN-CA':
      case 'FR-CA':
        regionCode = regions.CAN;
        break;
      case 'EN-US':
      default:
        regionCode = regions.USA;
        break;
    }
  }

  switch (regionCode) {
    case regions.CAN:
      return {
        backgroundColor: '#005238',
        color: '#EF6A00'
      };
    case regions.USA:
    default:
      return {
        backgroundColor: '#003968',
        color: '#EF6A00'
      };
  }
};
